import { encode } from 'base-64';
import { NotificationManager } from 'react-notifications';

export function safeEncode(encodedString, defaultValue = null) {
  try {
    return encode(encodedString);
  } catch (error) {
    NotificationManager.error("Error encoding:", error.message);
    return defaultValue;
  }
}